<span *ngIf="lengthError; else charsLeft">
  Error: Character limit is {{ maxLength }}, please shorten and try again
</span>
<ng-template #charsLeft>{{ characterleft }} charcter(s) left</ng-template>
